'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactSlick = require('components/ReactSlick/react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _SliderProductItem = require('./SliderProductItem');

var _SliderProductItem2 = _interopRequireDefault(_SliderProductItem);

var _SliderCategoryItem = require('./SliderCategoryItem');

var _SliderCategoryItem2 = _interopRequireDefault(_SliderCategoryItem);

require('./slick.less');

require('./slick-theme.less');

require('./GoodsSlider.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    GoodsSliderView: {
        displayName: 'GoodsSliderView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/GoodsSlider/default/GoodsSliderView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
} /**
   * Created by maximus on 30.12.16.
   */

var GoodsSliderView = _wrapComponent('GoodsSliderView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(GoodsSliderView, _Component);

    function GoodsSliderView() {
        (0, _classCallCheck3.default)(this, GoodsSliderView);
        return (0, _possibleConstructorReturn3.default)(this, (GoodsSliderView.__proto__ || (0, _getPrototypeOf2.default)(GoodsSliderView)).apply(this, arguments));
    }

    (0, _createClass3.default)(GoodsSliderView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                items = _props.items,
                contentType = _props.contentType;


            var prevArrow = _react3.default.createElement(
                'span',
                { className: 'arrow prev' },
                _react3.default.createElement('img', { src: '/assets/images/prev.svg', alt: '' })
            );

            var nextArrow = _react3.default.createElement(
                'span',
                { className: 'arrow next' },
                _react3.default.createElement('img', { src: '/assets/images/next.svg', alt: '' })
            );
            var slideCount = this.props.count || 3;
            var sliderON = true;
            if (items.length == 1) {
                sliderON = false;
            }

            var settings = {
                arrows: sliderON,
                className: "goods_slider",
                centerMode: false,
                dots: false,
                infinite: sliderON,
                lazyLoad: false,
                responsive: [{ breakpoint: 480, settings: { slidesToShow: 1 } }, { breakpoint: 768, settings: { slidesToShow: 2 } }, { breakpoint: 992, settings: { slidesToShow: slideCount - 1 } }, { breakpoint: 12000, settings: { slidesToShow: slideCount } }],
                nextArrow: nextArrow,
                prevArrow: prevArrow,
                speed: 500, //?
                slidesToShow: slideCount,
                slidesToScroll: 1,
                swipeToSlide: sliderON
            };
            return _react3.default.createElement(
                _reactSlick2.default,
                settings,
                items.map(function (item, i) {
                    if (contentType === 'product') {
                        return _react3.default.createElement(
                            'div',
                            { key: i },
                            _react3.default.createElement(_SliderProductItem2.default, {
                                key: item.id,
                                product: item,
                                updateProducts: _this2.props.updateProducts,
                                orderInOneClick: _this2.props.orderInOneClick,
                                buyInCreditActive: _this2.props.buyInCreditActive
                            })
                        );
                    }
                    if (contentType === 'category') {
                        return _react3.default.createElement(
                            'div',
                            { key: i },
                            _react3.default.createElement(_SliderCategoryItem2.default, { key: item.id, category: item })
                        );
                    }
                    return null;
                })
            );
        }
    }]);
    return GoodsSliderView;
}(_react2.Component), _class.propTypes = {
    items: _react2.PropTypes.array,
    count: _react2.PropTypes.number,
    contentType: _react2.PropTypes.string,
    updateProducts: _react2.PropTypes.func,
    orderInOneClick: _react2.PropTypes.bool
}, _temp));

exports.default = GoodsSliderView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GoodsSlider/default/GoodsSliderView.jsx
// module id = 1663
// module chunks = 0